<script>
export default {
  render(h) {
    return h("span", { class: "timer font__digifaw", ref: "timerDOM" });
  },
  data() {
    return {
      timer: null
    };
  },

  mounted() {
    const _this = this;
    const timerDOM = this.$refs.timerDOM;
    _this.timer = setInterval(() => {
      timerDOM.textContent = moment().format("YYYY-MM-DD HH:mm:ss");
    }, 1e3);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
